import { Box, useColorModeValue } from '@chakra-ui/react';

const TableBox = (props) => {
  const modeBoxBg = useColorModeValue('white', 'secondaryDark');

  return (
    <Box
      bg={modeBoxBg}
      borderRadius="12px"
      padding="28px 24px 36px"
      boxShadow="0px 5px 10px rgba(0, 0, 0, 0.05)"
      maxHeight={props.liveEventData ? '70vh' : null}
      overflow={props.liveEventData ? 'auto' : null}
      id={props.liveEventData && 'scrollableTable'}
    >
      {props.children}
    </Box>
  );
};

export default TableBox;
